import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';

export interface Supplier {
  id: number;
  code: string;
  name: string;
  contact_person?: string;
  phone?: string;
  email?: string;
  address?: string;
  bank_name?: string;
  bank_account?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface SupplierCreate {
  name: string;
  contact_person?: string;
  phone?: string;
  email?: string;
  address?: string;
  bank_name?: string;
  bank_account?: string;
  notes?: string;
}

export interface SupplierUpdate {
  name?: string;
  contact_person?: string;
  phone?: string;
  email?: string;
  address?: string;
  bank_name?: string;
  bank_account?: string;
  notes?: string;
}

const API_URL = `${API_BASE_URL}/suppliers`;

export const getSuppliers = async (params?: {
  search?: string;
  include_inactive?: boolean;
  page?: number;
  page_size?: number;
}): Promise<Supplier[]> => {
  const response = await api.get<Supplier[]>(API_URL, { params });
  return response.data;
};

export const getSupplierById = async (id: number): Promise<Supplier> => {
  const response = await api.get<Supplier>(`${API_URL}/${id}`);
  return response.data;
};

export const createSupplier = async (
  supplier: SupplierCreate
): Promise<Supplier> => {
  const response = await api.post<Supplier>(API_URL, supplier);
  return response.data;
};

export const updateSupplier = async (
  id: number,
  supplier: SupplierUpdate
): Promise<Supplier> => {
  const response = await api.patch<Supplier>(`${API_URL}/${id}`, supplier);
  return response.data;
};

export const deleteSupplier = async (
  id: number
): Promise<{ message: string }> => {
  const response = await api.delete<{ message: string }>(`${API_URL}/${id}`);
  return response.data;
};

// ============== ITEM-SUPPLIER LINKING ==============

export interface ItemSupplierCreate {
  item_id: number;
  supplier_id: number;
  brand?: string;
  cost_price: number;
  supplier_sku?: string;
  supplier_barcode?: string;
  lead_time_days?: number;
  is_preferred?: boolean;
}

export interface ItemSupplierResponse {
  id: number;
  item_id: number;
  supplier_id: number;
  brand?: string;
  supplier_sku?: string;
  supplier_barcode?: string;
  cost_price: number;
  lead_time_days: number;
  is_preferred: boolean;
}

export const linkItemToSupplier = async (
  data: ItemSupplierCreate
): Promise<ItemSupplierResponse> => {
  const response = await api.post<ItemSupplierResponse>(`${API_URL}/items`, data);
  return response.data;
};
